// Node Module Imports
import { keyframes } from 'styled-components'

export const rotate = keyframes`
    0% { transform: rotate(0deg); }
    10% { transform: rotate(5deg); }
    20% { transform: rotate(10deg); }
    30% { transform: rotate(20deg); }
    40% { transform: rotate(40deg); }
    50% { transform: rotate(80deg); }
    60% { transform: rotate(160deg); }
    70% { transform: rotate(320deg); }
    80% { transform: rotate(340deg); }
    90% { transform: rotate(350deg); }
    100% { transform: rotate(360deg); }
`

export const pulse = keyframes`
    0%   { transform: scale(1.0); }
    10%  { transform: scale(0.9); }
    20%  { transform: scale(0.8); }
    30%  { transform: scale(0.9); }
    40%  { transform: scale(1.0); }
    50%  { transform: scale(1.1); }
    60%  { transform: scale(1.2); }
    70%  { transform: scale(1.3); }
    80%  { transform: scale(1.2); }
    90%  { transform: scale(1.1); }
    100% { transform: scale(1.0); }
`
